const AGENCY_BADGE_MAP = {
  1: {
    label: 'Agent A',
    background:
      'linear-gradient(135deg, rgba(87, 67, 253, 0.95), rgba(91, 164, 255, 0.92))',
    border: 'rgba(255, 255, 255, 0.18)',
    shadow: 'rgba(91, 164, 255, 0.28)',
  },
  2: {
    label: 'Agent B',
    background:
      'linear-gradient(135deg, rgba(28, 146, 210, 0.95), rgba(36, 198, 220, 0.92))',
    border: 'rgba(255, 255, 255, 0.16)',
    shadow: 'rgba(36, 198, 220, 0.24)',
  },
  3: {
    label: 'Agent C',
    background:
      'linear-gradient(135deg, rgba(17, 153, 142, 0.95), rgba(56, 239, 125, 0.92))',
    border: 'rgba(255, 255, 255, 0.16)',
    shadow: 'rgba(56, 239, 125, 0.22)',
  },
  4: {
    label: 'Agent D',
    background:
      'linear-gradient(135deg, rgba(242, 153, 74, 0.95), rgba(242, 201, 76, 0.92))',
    border: 'rgba(255, 255, 255, 0.14)',
    shadow: 'rgba(242, 201, 76, 0.22)',
  },
  5: {
    label: 'Agent S',
    background:
      'linear-gradient(135deg, rgba(194, 21, 0, 0.95), rgba(255, 197, 0, 0.92))',
    border: 'rgba(255, 255, 255, 0.22)',
    shadow: 'rgba(255, 197, 0, 0.3)',
  },
} as const

export function BadgeAgency({ agencyLevel }: { agencyLevel: number }) {
  if (!agencyLevel) {
    return null
  }

  const currentBadge =
    AGENCY_BADGE_MAP[agencyLevel as keyof typeof AGENCY_BADGE_MAP]

  if (!currentBadge) {
    return null
  }

  return (
    <span
      className="inline-flex h-4 shrink-0 items-center justify-center rounded-full px-1.5 text-[7px] font-bold uppercase tracking-[0.04em] text-white align-middle"
      style={{
        background: currentBadge.background,
        border: `1px solid ${currentBadge.border}`,
        boxShadow: `0 2px 8px ${currentBadge.shadow}`,
        fontFamily: 'Nunito, sans-serif',
        lineHeight: 1,
      }}
    >
      <span style={{ position: 'relative', top: '1px' }}>{currentBadge.label}</span>
    </span>
  )
}
